(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["onebone-category-accordion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initOneBoneCategorySections(container = document) {
      const sections = container.querySelectorAll('[data-ob-category-section]');

      sections.forEach((section) => {
        if (section.dataset.obInitialized === 'true') return;

        const rail = section.querySelector('[data-ob-category-rail]');
        const cards = Array.from(section.querySelectorAll('[data-ob-category-card]'));
        const progressItems = Array.from(section.querySelectorAll('[data-ob-progress-item]'));
        const enableHover = section.dataset.hoverExpand === 'true';
        const inactiveStills = section.dataset.inactiveStills === 'true';

        if (!rail || cards.length === 0) return;

        section.dataset.obInitialized = 'true';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let sectionIsVisible = false;

        function syncCardMedia() {
          cards.forEach((card) => {
            const shouldPlay = sectionIsVisible && card.classList.contains('is-active') && !reduceMotion;

            card.querySelectorAll('.ob-category-card__video').forEach((video) => {
              const isVisibleSource = window.getComputedStyle(video).display !== 'none';

              if (shouldPlay && isVisibleSource) {
                video.play().catch(() => {});
              } else {
                video.pause();
                if (inactiveStills && video.readyState > 0) video.currentTime = 0;
              }
            });
          });
        }

        function setActiveCard(activeCard) {
          cards.forEach((card, index) => {
            const isActive = card === activeCard;
            card.classList.toggle('is-active', isActive);
            card.setAttribute('aria-current', isActive ? 'true' : 'false');

            if (progressItems[index]) {
              progressItems[index].classList.toggle('is-active', isActive);
            }
          });

          syncCardMedia();
        }

        cards.forEach((card) => {
          if (enableHover) {
            card.addEventListener('pointerenter', () => setActiveCard(card));
          }

          card.addEventListener('focusin', () => setActiveCard(card));
          card.addEventListener('click', (event) => {
            if (!event.target.closest('a')) setActiveCard(card);
          });
          card.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              setActiveCard(card);
            }
          });
        });

        let scrollFrame = null;

        rail.addEventListener('scroll', () => {
          if (!window.matchMedia('(max-width: 900px)').matches) return;
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);

          scrollFrame = window.requestAnimationFrame(() => {
            const railLeft = rail.getBoundingClientRect().left;
            let activeCard = cards[0];
            let smallestDistance = Number.POSITIVE_INFINITY;

            cards.forEach((card) => {
              const distance = Math.abs(card.getBoundingClientRect().left - railLeft);
              if (distance < smallestDistance) {
                smallestDistance = distance;
                activeCard = card;
              }
            });

            setActiveCard(activeCard);
          });
        }, { passive: true });

        const mediaObserver = new IntersectionObserver((entries) => {
          sectionIsVisible = entries.some((entry) => entry.isIntersecting);
          syncCardMedia();
        }, { threshold: 0.15 });

        mediaObserver.observe(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initOneBoneCategorySections());
    } else {
      initOneBoneCategorySections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initOneBoneCategorySections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-category-micro-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initOBMicroNav(container = document) {
      const sections = container.querySelectorAll('[data-ob-micro-nav]');

      sections.forEach((section) => {
        if (section.dataset.obMicroInitialized === 'true') return;

        const rail = section.querySelector('[data-ob-micro-rail]');
        const items = Array.from(section.querySelectorAll('[data-ob-micro-item]'));
        const prev = section.querySelector('[data-ob-micro-prev]');
        const next = section.querySelector('[data-ob-micro-next]');

        if (!rail || items.length === 0) return;

        section.dataset.obMicroInitialized = 'true';

        function setActiveItem(activeItem) {
          items.forEach((item) => {
            const isActive = item === activeItem;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-current', isActive ? 'page' : 'false');
          });
        }

        function scrollRail(direction) {
          const amount = Math.max(rail.clientWidth * 0.72, 220);
          rail.scrollBy({ left: amount * direction, behavior: 'smooth' });
        }

        items.forEach((item) => {
          item.addEventListener('click', () => setActiveItem(item));
        });

        if (prev) {
          prev.addEventListener('click', () => scrollRail(-1));
        }

        if (next) {
          next.addEventListener('click', () => scrollRail(1));
        }

        const currentPath = window.location.pathname.replace(/\/$/, '');
        const currentUrl = window.location.href.replace(/\/$/, '');
        const matchedItem = items.find((item) => {
          const itemHref = item.href.replace(/\/$/, '');
          const itemPath = new URL(item.href, window.location.origin).pathname.replace(/\/$/, '');
          return itemHref === currentUrl || itemPath === currentPath;
        });

        if (matchedItem) {
          setActiveItem(matchedItem);
          matchedItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initOBMicroNav());
    } else {
      initOBMicroNav();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initOBMicroNav(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-featured-product"] && !Shopify.designMode) return;
  try {
    
  (()=>{const roots=document.querySelectorAll('[data-obfp-section]');roots.forEach(root=>{if(root.dataset.obfpReady)return;root.dataset.obfpReady='true';const variantsNode=root.querySelector('[data-obfp-variants]'),form=root.querySelector('[data-obfp-form]');if(!variantsNode||!form)return;const variants=JSON.parse(variantsNode.textContent),variantInput=form.querySelector('[data-obfp-variant-id]'),inputs=[...form.querySelectorAll('[data-obfp-option-input]')],price=root.querySelector('[data-obfp-price]'),compare=root.querySelector('[data-obfp-compare]'),button=root.querySelector('[data-obfp-submit]'),buttonLabel=root.querySelector('[data-obfp-submit-label]'),buttonPrice=root.querySelector('[data-obfp-button-price]'),message=root.querySelector('[data-obfp-message]'),productLink=root.querySelector('[data-obfp-product-link]'),sticky=root.querySelector('[data-obfp-sticky]'),stickyButton=root.querySelector('[data-obfp-sticky-button]'),stickyLabel=root.querySelector('[data-obfp-sticky-label]'),stickyPrice=root.querySelector('[data-obfp-sticky-price]'),stickyVariant=root.querySelector('[data-obfp-sticky-variant]'),viewport=root.querySelector('[data-obfp-viewport]'),slides=[...root.querySelectorAll('[data-obfp-slide]')],thumbs=[...root.querySelectorAll('[data-obfp-thumbnail]')],current=root.querySelector('[data-obfp-current]');let activeVariant=variants.find(v=>String(v.id)===String(variantInput.value))||variants[0],activeSlide=0,buttonInView=true;const labels={add:root.dataset.addLabel,sold:root.dataset.soldLabel,adding:root.dataset.addingLabel,added:root.dataset.addedLabel,error:root.dataset.errorLabel,fitSelected:root.dataset.fitSelected,fitUnavailable:root.dataset.fitUnavailable,fitRecommendation:root.dataset.fitRecommendation},withSize=(template,size)=>template.replace('[size]',size),selectedOptions=()=>{const groups=[...form.querySelectorAll('[data-obfp-option]')];return groups.map(group=>group.querySelector('[data-obfp-option-input]:checked')?.value).filter(value=>value!==undefined)},findVariant=()=>{const selected=selectedOptions();return variants.find(variant=>variant.options.length===selected.length&&variant.options.every((value,index)=>value===selected[index]))},showSlide=index=>{if(!viewport||!slides.length)return;activeSlide=Math.max(0,Math.min(index,slides.length-1));slides[activeSlide].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});thumbs.forEach((thumb,i)=>{thumb.classList.toggle('is-active',i===activeSlide);thumb.setAttribute('aria-pressed',i===activeSlide?'true':'false')});if(current)current.textContent=String(activeSlide+1)},showMedia=id=>{if(!id)return;const index=slides.findIndex(slide=>String(slide.dataset.mediaId)===String(id));if(index>=0)showSlide(index)},setAvailability=()=>{const selected=selectedOptions();inputs.forEach(input=>{const position=Number(input.dataset.optionPosition)-1,candidate=[...selected];candidate[position]=input.value;const available=variants.some(variant=>variant.available&&variant.options.every((value,index)=>candidate[index]===undefined||value===candidate[index]));input.disabled=!available;input.closest('label')?.classList.toggle('is-unavailable',!available)})},update=()=>{const variant=findVariant();activeVariant=variant||null;setAvailability();if(!variant){variantInput.value='';button.disabled=true;if(stickyButton)stickyButton.disabled=true;message.textContent=labels.sold;return}variantInput.value=variant.id;price.textContent=variant.price_formatted;price.classList.toggle('is-sale',variant.compare_at_price>variant.price);if(variant.compare_at_price>variant.price){compare.textContent=variant.compare_at_price_formatted;compare.classList.remove('is-hidden')}else{compare.textContent='';compare.classList.add('is-hidden')}const available=variant.available;button.disabled=!available;buttonLabel.textContent=available?labels.add:labels.sold;buttonPrice.textContent=available?variant.price_formatted:'';if(stickyButton)stickyButton.disabled=!available;if(stickyLabel)stickyLabel.textContent=available?labels.add:labels.sold;if(stickyPrice)stickyPrice.textContent=available?variant.price_formatted:'';if(stickyVariant)stickyVariant.textContent=variant.title;if(productLink)productLink.href=`${productLink.href.split('?')[0]}?variant=${variant.id}`;message.textContent='';showMedia(variant.featured_media_id)};inputs.forEach(input=>input.addEventListener('change',update));thumbs.forEach(thumb=>thumb.addEventListener('click',()=>showSlide(Number(thumb.dataset.obfpThumbnail))));root.querySelector('[data-obfp-previous]')?.addEventListener('click',()=>showSlide(activeSlide-1));root.querySelector('[data-obfp-next]')?.addEventListener('click',()=>showSlide(activeSlide+1));if(viewport){let ticking=false;viewport.addEventListener('scroll',()=>{if(ticking)return;ticking=true;requestAnimationFrame(()=>{const width=viewport.clientWidth||1,position=Math.round(viewport.scrollLeft/width);if(position!==activeSlide){activeSlide=position;thumbs.forEach((thumb,i)=>{thumb.classList.toggle('is-active',i===activeSlide);thumb.setAttribute('aria-pressed',i===activeSlide?'true':'false')});if(current)current.textContent=String(activeSlide+1)}ticking=false})},{passive:true})}const emailCodeLink=root.querySelector('[data-obfp-email-code]');emailCodeLink?.addEventListener('click',event=>{event.preventDefault();window._klOnsite=window._klOnsite||[];window._klOnsite.push(['openForm','W5sKSn'])});const fit=root.querySelector('[data-obfp-fit]'),openFit=root.querySelector('[data-obfp-open-fit]'),height=root.querySelector('[data-obfp-height]'),weight=root.querySelector('[data-obfp-weight]'),heightOutput=root.querySelector('[data-obfp-height-output]'),weightOutput=root.querySelector('[data-obfp-weight-output]'),fitSize=root.querySelector('[data-obfp-fit-size]'),fitMessage=root.querySelector('[data-obfp-fit-message]'),matrix=[{max:179,s:['-2','-2','-2','-1','-1','-1','-1']},{max:189,s:['-1','-1','-1','-1','-1','-1','-1']},{max:199,s:['0','0','-1','-1','-1','-1','-1']},{max:209,s:['0','0','0','0','0','0','0']},{max:219,s:['0','0','0','0','0','0','0']},{max:229,s:['0','0','0','0','0','0','0']},{max:239,s:['0','0','0','0','0','0','0']},{max:249,s:['0','0','0','0','0','0','0']},{max:259,s:['1','1','1','0','0','0','0']},{max:269,s:['1','1','1','1','1','1','1']},{max:279,s:['2','1','1','1','1','1','1']},{max:289,s:['2','2','1','1','1','1','1']},{max:299,s:['2','2','1','1','1','1','1']},{max:309,s:['2','2','1','1','1','1','1']},{max:319,s:['3','3','2','2','2','1','1']},{max:329,s:['3','3','2','2','2','2','2']},{max:339,s:['3','3','3','3','3','3','3']},{max:349,s:['4','4','3','3','3','3','3']},{max:359,s:['4','4','3','3','3','3','3']},{max:369,s:['4','4','4','4','4','4','4']},{max:379,s:['4','4','4','4','4','4','4']},{max:389,s:['5','5','4','4','4','3','3']},{max:399,s:['5','5','5','4','4','4','4']},{max:409,s:['5','5','5','5','5','5','5']},{max:419,s:['5','5','5','5','5','5','5']},{max:429,s:['5','5','5','5','5','5','5']},{max:439,s:['6','5','5','5','5','5','5']},{max:449,s:['6','6','6','6','6','6','6']},{max:459,s:['6','6','6','6','6','6','6']},{max:469,s:['6','6','6','6','6','6','6']},{max:479,s:['6','6','6','6','6','6','6']},{max:489,s:['6','6','6','6','6','6','6']},{max:499,s:['7','7','7','7','7','7','7']},{max:Infinity,s:['7','7','7','7','7','7','7']}],heightColumn=value=>value<=68?0:value<=71?1:value<=74?2:value<=77?3:value<=80?4:value<=83?5:6,normalize=value=>String(value).toLowerCase().replace(/^size\s*/,'').trim(),recommend=()=>{if(!height||!weight)return;const inches=Number(height.value),pounds=Number(weight.value),row=matrix.find(range=>pounds<=range.max)||matrix[matrix.length-1],size=row.s[heightColumn(inches)];heightOutput.textContent=`${Math.floor(inches/12)}'${inches%12}\"`;weightOutput.textContent=pounds>=500?'500 lb+':`${pounds} lb`;fitSize.textContent=size;const sizeGroup=[...form.querySelectorAll('[data-obfp-option]')].find(group=>group.dataset.optionName.toLowerCase().includes('size'));const sizeInput=sizeGroup?[...sizeGroup.querySelectorAll('[data-obfp-option-input]')].find(input=>normalize(input.value)===normalize(size)):null;if(sizeInput&&!sizeInput.disabled){if(!sizeInput.checked){sizeInput.checked=true;sizeInput.dispatchEvent(new Event('change',{bubbles:true}))}fitMessage.textContent=withSize(labels.fitSelected,size)}else if(sizeInput){fitMessage.textContent=withSize(labels.fitUnavailable,size)}else{fitMessage.textContent=withSize(labels.fitRecommendation,size)}};openFit?.addEventListener('click',()=>{fit.open=!fit.open;openFit.setAttribute('aria-expanded',fit.open?'true':'false');if(fit.open)fit.scrollIntoView({behavior:'smooth',block:'nearest'})});fit?.addEventListener('toggle',()=>openFit?.setAttribute('aria-expanded',fit.open?'true':'false'));height?.addEventListener('input',recommend);weight?.addEventListener('input',recommend);recommend();form.addEventListener('submit',async event=>{if(!activeVariant||!activeVariant.available){event.preventDefault();message.textContent=labels.sold;form.querySelector('[data-obfp-option-input]:not(:disabled)')?.focus();return}if(!window.fetch)return;event.preventDefault();button.disabled=true;message.textContent=labels.adding;const data=new FormData(form);try{const helper=window.Alpine?.store?.('xCartHelper');if(helper){data.append('sections',helper.getSectionsToRender().map(section=>section.id));data.append('sections_url',window.location.pathname)}const endpoint=window.Eurus?.cart_add_url||`${window.Shopify?.routes?.root||'/'}cart/add.js`,response=await fetch(endpoint,{method:'POST',headers:{Accept:'application/javascript','X-Requested-With':'XMLHttpRequest'},body:data}),result=await response.json();if(!response.ok||result.status===422)throw new Error(result.description||labels.error);if(helper&&result.sections)helper.reRenderSections(result.sections);const notice=window.Alpine?.store?.('xCartNoti');if(notice?.enable)notice.setItem(result);const miniCart=window.Alpine?.store?.('xMiniCart');if(miniCart&&!notice?.enable)miniCart.openCart();document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));message.textContent=labels.added}catch(error){message.textContent=error.message||labels.error}finally{button.disabled=!activeVariant?.available}});stickyButton?.addEventListener('click',()=>{if(button.disabled){form.querySelector('[data-obfp-option-input]:not(:disabled)')?.focus();form.scrollIntoView({behavior:'smooth',block:'center'});return}button.click()});if(sticky&&button){const observer=new IntersectionObserver(entries=>{buttonInView=entries[0].isIntersecting;updateSticky()},{threshold:.1}),updateSticky=()=>{const rect=root.getBoundingClientRect(),sectionVisible=rect.top<window.innerHeight&&rect.bottom>0,show=sectionVisible&&!buttonInView&&rect.top<0;sticky.classList.toggle('is-visible',show);sticky.setAttribute('aria-hidden',show?'false':'true')};observer.observe(button);window.addEventListener('scroll',updateSticky,{passive:true})}update()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-fit-lock-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const matrix=[{max:179,s:['-2','-2','-2','-1','-1','-1','-1']},{max:189,s:['-1','-1','-1','-1','-1','-1','-1']},{max:199,s:['0','0','-1','-1','-1','-1','-1']},{max:209,s:['0','0','0','0','0','0','0']},{max:219,s:['0','0','0','0','0','0','0']},{max:229,s:['0','0','0','0','0','0','0']},{max:239,s:['0','0','0','0','0','0','0']},{max:249,s:['0','0','0','0','0','0','0']},{max:259,s:['1','1','1','0','0','0','0']},{max:269,s:['1','1','1','1','1','1','1']},{max:279,s:['2','1','1','1','1','1','1']},{max:289,s:['2','2','1','1','1','1','1']},{max:299,s:['2','2','1','1','1','1','1']},{max:309,s:['2','2','1','1','1','1','1']},{max:319,s:['3','3','2','2','2','1','1']},{max:329,s:['3','3','2','2','2','2','2']},{max:339,s:['3','3','3','3','3','3','3']},{max:349,s:['4','4','3','3','3','3','3']},{max:359,s:['4','4','3','3','3','3','3']},{max:369,s:['4','4','4','4','4','4','4']},{max:379,s:['4','4','4','4','4','4','4']},{max:389,s:['5','5','4','4','4','3','3']},{max:399,s:['5','5','5','4','4','4','4']},{max:409,s:['5','5','5','5','5','5','5']},{max:419,s:['5','5','5','5','5','5','5']},{max:429,s:['5','5','5','5','5','5','5']},{max:439,s:['6','5','5','5','5','5','5']},{max:449,s:['6','6','6','6','6','6','6']},{max:459,s:['6','6','6','6','6','6','6']},{max:469,s:['6','6','6','6','6','6','6']},{max:479,s:['6','6','6','6','6','6','6']},{max:489,s:['6','6','6','6','6','6','6']},{max:499,s:['7','7','7','7','7','7','7']},{max:Infinity,s:['7','7','7','7','7','7','7']}];
    const bottoms=[{min:30,max:33,size:'A'},{min:34,max:37,size:'B'},{min:38,max:40,size:'C'},{min:41,max:44,size:'D'},{min:45,max:49,size:'E'},{min:50,max:54,size:'F'},{min:55,max:60,size:'G'},{min:61,max:65,size:'H'}];
    const heightColumn=(value)=>value<=68?0:value<=71?1:value<=74?2:value<=77?3:value<=80?4:value<=83?5:6;
    const normalize=(value)=>String(value||'').toLowerCase().replace(/^size\s*/,'').replace(/\s*\([^)]*\)\s*$/,'').trim();

    const init=(scope=document)=>scope.querySelectorAll('[data-obflc]').forEach((root)=>{
      if(root.dataset.ready==='true')return;root.dataset.ready='true';
      const height=root.querySelector('[data-obflc-height]'),weight=root.querySelector('[data-obflc-weight]'),waist=root.querySelector('[data-obflc-waist]');
      const heightOut=root.querySelector('[data-obflc-height-output]'),weightOut=root.querySelector('[data-obflc-weight-output]'),waistOut=root.querySelector('[data-obflc-waist-output]');
      const topOut=root.querySelector('[data-obflc-top-size]'),bottomOut=root.querySelector('[data-obflc-bottom-size]'),modalSize=root.querySelector('[data-obflc-modal-size]');
      const modal=root.querySelector('[data-obflc-modal]'),primary=root.querySelector('[data-obflc-primary-stage]'),promo=root.querySelector('[data-obflc-promo-stage]');
      const selector=root.querySelector('[data-obflc-product-select]'),image=root.querySelector('[data-obflc-image]'),variantText=root.querySelector('[data-obflc-variant]'),price=root.querySelector('[data-obflc-price]'),link=root.querySelector('[data-obflc-link]');
      const add=root.querySelector('[data-obflc-add]'),addLabel=root.querySelector('[data-obflc-add-label]'),status=root.querySelector('[data-obflc-status]');
      const productsNode=root.querySelector('[data-obflc-products]'),products=productsNode?JSON.parse(productsNode.textContent):[];
      const promoNode=root.querySelector('[data-obflc-promo-data]'),promoData=promoNode?JSON.parse(promoNode.textContent):null;
      const promoSize=root.querySelector('[data-obflc-promo-size]'),promoVariant=root.querySelector('[data-obflc-promo-variant]'),promoAdd=root.querySelector('[data-obflc-promo-add]'),promoLabel=root.querySelector('[data-obflc-promo-label]'),promoStatus=root.querySelector('[data-obflc-promo-status]');
      let topSize='1',bottomSize='C',current=products[0]||null,selected=null,selectedPromo=null;

      const updateFit=()=>{const inches=Number(height.value),pounds=Number(weight.value),row=matrix.find((item)=>pounds<=item.max)||matrix[matrix.length-1];topSize=row.s[heightColumn(inches)];bottomSize=(bottoms.find((item)=>Number(waist.value)>=item.min&&Number(waist.value)<=item.max)||bottoms[0]).size;heightOut.textContent=`${Math.floor(inches/12)}'${inches%12}"`;weightOut.textContent=pounds>=500?'500 lb+':`${pounds} lb`;waistOut.textContent=`${waist.value} in`;topOut.textContent=topSize;bottomOut.textContent=bottomSize;if(modalSize)modalSize.textContent=topSize;};
      const chooseVariant=()=>{if(!current)return false;const matches=current.variants.filter((item)=>normalize(item.options?.[current.sizeIndex])===normalize(topSize));selected=matches.find((item)=>item.available)||matches[0]||null;variantText.textContent=selected?selected.title:`Size ${topSize} unavailable`;price.textContent=selected?.price||'';if(image&&(selected?.image||current.image)){image.src=selected?.image||current.image;image.alt=current.title;}if(link)link.href=selected?`${current.url}?variant=${selected.id}`:current.url;add.disabled=!selected?.available;return Boolean(selected?.available);};
      const chooseProduct=()=>{current=products.find((item)=>String(item.id)===selector.value)||products[0]||null;chooseVariant();status.textContent='';};
      [height,weight,waist].forEach((input)=>input?.addEventListener('input',()=>{updateFit();chooseVariant();}));selector?.addEventListener('change',chooseProduct);
      if(addLabel)add.dataset.defaultLabel=addLabel.textContent.trim();if(promoLabel)promoAdd.dataset.defaultLabel=promoLabel.textContent.trim();
      const addToCart=async(id,properties={},silent=false)=>{const form=new FormData();form.append('id',id);form.append('quantity','1');Object.entries(properties).forEach(([key,value])=>form.append(`properties[${key}]`,value));const helper=window.Alpine?.store?.('xCartHelper');if(helper&&!silent){form.append('sections',helper.getSectionsToRender().map((item)=>item.id));form.append('sections_url',window.location.pathname);}const response=await fetch(window.Eurus?.cart_add_url||`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{Accept:'application/javascript','X-Requested-With':'XMLHttpRequest'},body:form});const result=await response.json();if(!response.ok||result.status===422)throw new Error(result.description||'Unable to add this size.');if(!silent){if(helper&&result.sections)helper.reRenderSections(result.sections);document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));}return result;};
      const offerPromo=async()=>{if(!promo||root.dataset.promoEligible!=='true')return false;try{const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{headers:{Accept:'application/json'}});if(response.ok){const cart=await response.json();if(cart.items?.some((item)=>item.properties?.['_ONE BONE offer']==='First-order underwear'))return false;}}catch(error){}return true;};
      const preparePromo=()=>{const requested=Number(waist.value),internal=(bottoms.find((item)=>requested>=item.min&&requested<=item.max)||bottoms[0]).size,matches=promoData?.variants?.filter((item)=>normalize(item.options?.[promoData.sizeIndex])===normalize(internal))||[];selectedPromo=matches.find((item)=>item.available)||matches[0]||null;promoSize.textContent=internal;promoVariant.textContent=`Size ${internal} · ${requested} in waist`;promoAdd.disabled=!selectedPromo?.available;promoStatus.textContent=selectedPromo?.available?'':`The option for a ${requested} in waist is unavailable.`;};
      const openCart=(result)=>{const notice=window.Alpine?.store?.('xCartNoti');if(notice?.enable)notice.setItem(result);const mini=window.Alpine?.store?.('xMiniCart');if(mini?.openCart)mini.openCart();else window.setTimeout(()=>{window.location.href=`${window.Shopify?.routes?.root||'/'}cart`;},250);};
      root.querySelector('[data-obflc-lock]')?.addEventListener('click',()=>{updateFit();chooseProduct();try{localStorage.setItem('oneboneLockedTopSize',topSize);localStorage.setItem('oneboneLockedWaist',String(waist.value));localStorage.setItem('sizeBottom',bottomSize);localStorage.setItem('bottoms-product-size',bottomSize);}catch(error){}primary.hidden=false;if(promo)promo.hidden=true;modal.showModal();});
      root.querySelector('[data-obflc-close]')?.addEventListener('click',()=>modal.close());modal?.addEventListener('click',(event)=>{if(event.target===modal)modal.close();});
      add?.addEventListener('click',async()=>{if(!selected?.available)return;add.disabled=true;addLabel.textContent='Adding…';status.textContent='';try{const shouldPromo=await offerPromo(),result=await addToCart(selected.id,{},shouldPromo);addLabel.textContent='Added to bag ✓';status.textContent=`${current.title} in size ${topSize} is in your bag.`;if(shouldPromo){preparePromo();primary.hidden=true;promo.hidden=false;}else{openCart(result);}}catch(error){add.disabled=false;addLabel.textContent=add.dataset.defaultLabel;status.textContent=error.message||'Unable to add this item.';}});
      promoAdd?.addEventListener('click',async()=>{preparePromo();if(!selectedPromo?.available)return;promoAdd.disabled=true;promoLabel.textContent='Adding…';try{const result=await addToCart(selectedPromo.id,{'_ONE BONE offer':'First-order underwear'});const code=root.dataset.promoDiscountCode?.trim();if(code)await fetch(`${window.Shopify?.routes?.root||'/'}discount/${encodeURIComponent(code)}`,{credentials:'same-origin'});promoLabel.textContent='Free pair added ✓';promoStatus.textContent=`Size ${bottomSize} is in your bag.`;modal.close();openCart(result);}catch(error){promoAdd.disabled=false;promoLabel.textContent=promoAdd.dataset.defaultLabel;promoStatus.textContent=error.message||'Unable to add this item.';}});
      updateFit();chooseProduct();
    });
    init();document.addEventListener('shopify:section:load',(event)=>init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-fit-lock"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // The line item property the new-customer gift discount function looks for.
    // It has to match snippets/gwp-gift.liquid and assets/gwp-gift.js, and the
    // `_gwp` key the checkout notice reads. Without it the function leaves the
    // line at full price, because it cannot tell a gift from a deliberate
    // purchase of the same boxer brief.
    //
    // Which variants may carry it is decided in Liquid, above: the promo variant
    // list is already narrowed to gwp.gift_variants, so anything this resolves
    // by size is a variant the function will discount. Nothing here re-checks
    // that — a second opinion could only differ from the first, and would be the
    // weaker of the two.
    const GIFT_PROPERTY = '_gwp';
    const GIFT_PROPERTY_VALUE = 'new-customer-underwear';

    const matrix = [{max:179,s:['-2','-2','-2','-1','-1','-1','-1']},{max:189,s:['-1','-1','-1','-1','-1','-1','-1']},{max:199,s:['0','0','-1','-1','-1','-1','-1']},{max:209,s:['0','0','0','0','0','0','0']},{max:219,s:['0','0','0','0','0','0','0']},{max:229,s:['0','0','0','0','0','0','0']},{max:239,s:['0','0','0','0','0','0','0']},{max:249,s:['0','0','0','0','0','0','0']},{max:259,s:['1','1','1','0','0','0','0']},{max:269,s:['1','1','1','1','1','1','1']},{max:279,s:['2','1','1','1','1','1','1']},{max:289,s:['2','2','1','1','1','1','1']},{max:299,s:['2','2','1','1','1','1','1']},{max:309,s:['2','2','1','1','1','1','1']},{max:319,s:['3','3','2','2','2','1','1']},{max:329,s:['3','3','2','2','2','2','2']},{max:339,s:['3','3','3','3','3','3','3']},{max:349,s:['4','4','3','3','3','3','3']},{max:359,s:['4','4','3','3','3','3','3']},{max:369,s:['4','4','4','4','4','4','4']},{max:379,s:['4','4','4','4','4','4','4']},{max:389,s:['5','5','4','4','4','3','3']},{max:399,s:['5','5','5','4','4','4','4']},{max:409,s:['5','5','5','5','5','5','5']},{max:419,s:['5','5','5','5','5','5','5']},{max:429,s:['5','5','5','5','5','5','5']},{max:439,s:['6','5','5','5','5','5','5']},{max:449,s:['6','6','6','6','6','6','6']},{max:459,s:['6','6','6','6','6','6','6']},{max:469,s:['6','6','6','6','6','6','6']},{max:479,s:['6','6','6','6','6','6','6']},{max:489,s:['6','6','6','6','6','6','6']},{max:499,s:['7','7','7','7','7','7','7']},{max:Infinity,s:['7','7','7','7','7','7','7']}];
    // Waist sizing comes from assets/fit-finder.js (OB-232). This section used to
    // carry its own copy of the A–H ranges, which had drifted from the ONE BONE
    // size guide matrix.
    const heightColumn = (value) => value <= 68 ? 0 : value <= 71 ? 1 : value <= 74 ? 2 : value <= 77 ? 3 : value <= 80 ? 4 : value <= 83 ? 5 : 6;
    const normalize = (value) => String(value || '').toLowerCase().replace(/^size\s*/, '').replace(/\s*\([^)]*\)\s*$/, '').trim();

    const init = (scope = document) => {
      scope.querySelectorAll('[data-obfl]').forEach((root) => {
        if (root.dataset.ready === 'true') return;
        root.dataset.ready = 'true';

        const height = root.querySelector('[data-obfl-height]');
        const weight = root.querySelector('[data-obfl-weight]');
        const waist = root.querySelector('[data-obfl-waist]');
        const heightOutput = root.querySelector('[data-obfl-height-output]');
        const weightOutput = root.querySelector('[data-obfl-weight-output]');
        const waistOutput = root.querySelector('[data-obfl-waist-output]');
        const sizeOutput = root.querySelector('[data-obfl-size]');
        const bottomSizeOutput = root.querySelector('[data-obfl-bottom-size]');
        const bottomWaistOutput = root.querySelector('[data-obfl-bottom-waist]');
        const modalSize = root.querySelector('[data-obfl-modal-size]');
        const lockButton = root.querySelector('[data-obfl-lock]');
        const lockedMessage = root.querySelector('[data-obfl-locked-message]');
        const calculatorStage = root.querySelector('[data-obfl-calculator-stage]');
        const inlineFlow = root.querySelector('[data-obfl-inline-flow]');
        const inlineMode = root.dataset.displayMode === 'inline';
        const modal = root.querySelector('[data-obfl-modal]');
        const closeButton = root.querySelector('[data-obfl-close]');
        const addButton = root.querySelector('[data-obfl-add]');
        const addLabel = root.querySelector('[data-obfl-add-label]');
        const status = root.querySelector('[data-obfl-status]');
        const variantTitle = root.querySelector('[data-obfl-variant-title]');
        const price = root.querySelector('[data-obfl-price]');
        const image = root.querySelector('[data-obfl-product-image]');
        const productLink = root.querySelector('[data-obfl-product-link]');
        const productTitle = root.querySelector('[data-obfl-product-title]');
        const productsNode = root.querySelector('[data-obfl-products]');
        const products = productsNode ? JSON.parse(productsNode.textContent) : {fallback:null,rules:[]};
        const primaryStage = root.querySelector('[data-obfl-primary-stage]');
        const promoStage = root.querySelector('[data-obfl-promo-stage]');
        const promoSizeBadge = root.querySelector('[data-obfl-promo-size-badge]');
        const promoResult = root.querySelector('[data-obfl-promo-result]');
        const promoVariantTitle = root.querySelector('[data-obfl-promo-variant-title]');
        const promoAdd = root.querySelector('[data-obfl-promo-add]');
        const promoAddLabel = root.querySelector('[data-obfl-promo-add-label]');
        const promoStatus = root.querySelector('[data-obfl-promo-status]');
        const promoNode = root.querySelector('[data-obfl-promo-variants]');
        const promoData = promoNode ? JSON.parse(promoNode.textContent) : null;
        let currentProduct = products.fallback;
        let recommendedSize = '2';
        let recommendedWaist = Number(waist?.value || 40);
        let recommendedBottom = '';
        let selectedVariant = null;
        let promoVariant = null;

        if (inlineMode && inlineFlow) {
          if (primaryStage) inlineFlow.appendChild(primaryStage);
          if (promoStage) inlineFlow.appendChild(promoStage);
        }

        const renderProductImage = (source) => {
          if (!image || !source) return;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = source;
          image.alt = currentProduct?.title || image.alt;
        };

        const chooseProduct = (inches) => {
          const match = (products.rules || []).find((rule) => rule.enabled && inches >= Number(rule.minHeight) && inches <= Number(rule.maxHeight));
          currentProduct = match || products.fallback;
          if (!currentProduct) return;
          if (productTitle) productTitle.textContent = currentProduct.title || '';
          renderProductImage(currentProduct.image);
          if (productLink) productLink.href = currentProduct.url;
        };

        // Waist -> A-H comes from assets/fit-finder.js, which the section script
        // may load before. Until it is there the letter is left blank rather
        // than guessed from a second copy of the ranges.
        const bottomSizeFor = (inches) => window.OneBoneFit?.recommendBottom(inches) || '';

        const update = () => {
          const inches = Number(height.value);
          const pounds = Number(weight.value);
          const row = matrix.find((range) => pounds <= range.max) || matrix[matrix.length - 1];
          recommendedSize = row.s[heightColumn(inches)];
          recommendedWaist = Number(waist?.value || recommendedWaist);
          recommendedBottom = bottomSizeFor(recommendedWaist);
          chooseProduct(inches);
          heightOutput.textContent = `${Math.floor(inches / 12)}'${inches % 12}"`;
          weightOutput.textContent = pounds >= 500 ? '500 lb+' : `${pounds} lb`;
          if (waistOutput) waistOutput.textContent = `${recommendedWaist} in`;
          sizeOutput.textContent = recommendedSize;
          if (bottomSizeOutput) bottomSizeOutput.textContent = recommendedBottom || '—';
          if (bottomWaistOutput) bottomWaistOutput.textContent = `${recommendedWaist} in waist`;
          if (modalSize) modalSize.textContent = recommendedSize;
          syncPromoSelection();
        };

        const selectVariant = () => {
          if (!currentProduct) return false;
          const matching = currentProduct.variants.filter((variant) => normalize(variant.options?.[currentProduct.sizeIndex]) === normalize(recommendedSize));
          selectedVariant = matching.find((variant) => variant.available) || matching[0] || null;
          if (!selectedVariant) return false;
          if (productTitle) productTitle.textContent = currentProduct.title || '';
          if (variantTitle) variantTitle.textContent = selectedVariant.title;
          if (price) price.textContent = selectedVariant.price;
          if (selectedVariant.image && !currentProduct.imageOverride) renderProductImage(selectedVariant.image);
          if (productLink) productLink.href = `${currentProduct.url}?variant=${selectedVariant.id}`;
          if (addButton) addButton.disabled = !selectedVariant.available;
          if (addLabel) addLabel.textContent = selectedVariant.available ? addButton.dataset.defaultLabel : 'Size unavailable';
          return true;
        };

        height?.addEventListener('input', update);
        weight?.addEventListener('input', update);
        waist?.addEventListener('input', update);

        if (addButton && addLabel) addButton.dataset.defaultLabel = addLabel.textContent.trim();
        if (promoAdd && promoAddLabel) promoAdd.dataset.defaultLabel = promoAddLabel.textContent.trim();

        // The offer stage no longer asks for a waist, so the free pair is
        // resolved from the measurement the calculator already has. Kept in step
        // with the slider so the pair is ready the moment the stage appears.
        const syncPromoSelection = () => {
          if (!promoStage) return null;
          const visibleWaist = `${recommendedWaist} in`;
          const internalSize = recommendedBottom || bottomSizeFor(recommendedWaist);
          recommendedBottom = internalSize;
          const matching = internalSize
            ? (promoData?.variants || []).filter((variant) => normalize(variant.options?.[promoData.sizeIndex]) === normalize(internalSize))
            : [];
          promoVariant = matching.find((variant) => variant.available) || matching[0] || null;
          if (promoSizeBadge) promoSizeBadge.textContent = `${recommendedWaist}\u2033`;
          if (promoVariantTitle) promoVariantTitle.textContent = internalSize ? `${visibleWaist} waist — size ${internalSize}` : `${visibleWaist} waist`;
          if (promoResult) promoResult.hidden = false;
          const available = Boolean(promoVariant?.available);
          if (promoAdd) promoAdd.disabled = !available;
          if (promoAddLabel) promoAddLabel.textContent = available ? promoAdd.dataset.defaultLabel : 'Size unavailable';
          if (promoStatus) promoStatus.textContent = available || !internalSize ? '' : `The option for a ${visibleWaist} waist is currently unavailable.`;
          return promoVariant;
        };

        const addToCart = async (variantId, properties = {}) => {
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');
          Object.entries(properties).forEach(([key,value]) => formData.append(`properties[${key}]`, value));
          const helper = window.Alpine?.store?.('xCartHelper');
          if (helper) {
            formData.append('sections', helper.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
          }
          const endpoint = window.Eurus?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
          const response = await fetch(endpoint, {method:'POST',headers:{Accept:'application/javascript','X-Requested-With':'XMLHttpRequest'},body:formData});
          const result = await response.json();
          if (!response.ok || result.status === 422) throw new Error(result.description || 'Unable to add this size.');
          if (helper && result.sections) helper.reRenderSections(result.sections);
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          return result;
        };

        const showPromo = async () => {
          if (!promoStage || root.dataset.promoEligible !== 'true') return false;
          try {
            const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers:{Accept:'application/json'}});
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              const items = cart.items || [];
              // GIFT_PROPERTY is the current marker; the old key is still
              // checked so a cart from before this change is not offered a
              // second pair.
              const isGift = (item) => Boolean(item.properties?.[GIFT_PROPERTY])
                || item.properties?.['_ONE BONE offer'] === 'First-order underwear';
              if (items.some(isGift)) return false;

              // The function requires a purchase alongside the gift, and honours
              // the same minimum. Offering the pair below the threshold would
              // mean the discount is refused and the shopper pays for it.
              const paid = items.filter((item) => !isGift(item))
                .reduce((total, item) => total + (item.final_line_price || 0), 0);
              const minimum = Number(root.dataset.promoMinSubtotal || 0);
              if (paid <= 0 || paid < minimum) return false;
            }
          } catch (error) {}
          primaryStage.hidden = true;
          promoStage.hidden = false;
          if (promoStatus) promoStatus.textContent = '';
          syncPromoSelection();
          return true;
        };

        lockButton?.addEventListener('click', () => {
          update();
          try {
            localStorage.setItem('oneboneLockedTopSize', recommendedSize);
            localStorage.setItem('oneboneLockedWaist', String(recommendedWaist));
            if (recommendedBottom) localStorage.setItem('bottoms-product-size', recommendedBottom);
          } catch (error) {}
          // Share the whole fit with the rest of the theme (OB-232). The
          // measurements go in first so the engine recalculates from them, then
          // the two sizes shown here are pinned so nothing can disagree with
          // what the shopper just read.
          window.OneBoneFit?.setProfile({
            height: Number(height.value),
            weight: Number(weight.value),
            waist: recommendedWaist
          }, 'fit-lock');
          window.OneBoneFit?.setSizes({ top: recommendedSize, bottom: recommendedBottom || undefined });
          if (lockedMessage) {
            lockedMessage.textContent = recommendedBottom
              ? `Size ${recommendedSize} and a ${recommendedWaist} in waist are locked in.`
              : `Size ${recommendedSize} is locked in.`;
            lockedMessage.hidden = false;
          }
          if (status) status.textContent = '';
          selectVariant();
          if (primaryStage) primaryStage.hidden = false;
          if (promoStage) promoStage.hidden = true;
          if (inlineMode && inlineFlow) {
            calculatorStage.hidden = true;
            inlineFlow.hidden = false;
            inlineFlow.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'nearest'});
          } else {
            modal?.showModal();
          }
        });

        closeButton?.addEventListener('click', () => modal?.close());
        modal?.addEventListener('click', (event) => {
          if (event.target === modal) modal.close();
        });

        addButton?.addEventListener('click', async () => {
          if (!selectedVariant?.available) return;
          addButton.disabled = true;
          addLabel.textContent = 'Adding…';
          if (status) status.textContent = '';

          try {
            const result = await addToCart(selectedVariant.id);
            addLabel.textContent = 'Added to bag ✓';
            if (status) status.textContent = `Size ${recommendedSize} is in your bag.`;
            if (!(await showPromo())) {
              const notice = window.Alpine?.store?.('xCartNoti');
              if (notice?.enable) notice.setItem(result);
              const miniCart = window.Alpine?.store?.('xMiniCart');
              if (miniCart && !notice?.enable) miniCart.openCart();
            }
          } catch (error) {
            addLabel.textContent = addButton.dataset.defaultLabel;
            addButton.disabled = false;
            if (status) status.textContent = error.message || 'Unable to add this item. Please try again.';
          }
        });

        promoAdd?.addEventListener('click', async () => {
          // The waist came from the calculator, so there is nothing to read from
          // this stage — only the variant it resolved to.
          const requestedWaist = recommendedWaist;
          const visibleSize = `${requestedWaist} in`;
          const variant = promoVariant || syncPromoSelection();
          if (!variant?.available) {
            if (promoStatus) promoStatus.textContent = `The option for a ${visibleSize} waist is currently unavailable.`;
            return;
          }
          promoAdd.disabled = true;
          promoAddLabel.textContent = 'Locking it in…';
          if (promoStatus) promoStatus.textContent = '';
          try {
            const result = await addToCart(variant.id, {[GIFT_PROPERTY]: GIFT_PROPERTY_VALUE});
            const discountCode = root.dataset.promoDiscountCode?.trim();
            if (discountCode) {
              await fetch(`${window.Shopify?.routes?.root || '/'}discount/${encodeURIComponent(discountCode)}`, {credentials:'same-origin'});
            }
            try {
              localStorage.setItem('oneboneFirstOrderPromoClaimed', 'true');
            } catch (error) {}
            promoAddLabel.textContent = 'Free pair added ✓';
            if (promoStatus) promoStatus.textContent = `${visibleSize} waist is locked in and added to your bag.`;
            const notice = window.Alpine?.store?.('xCartNoti');
            if (notice?.enable) notice.setItem(result);
            if (modal?.open) modal.close();
            const miniCart = window.Alpine?.store?.('xMiniCart');
            if (miniCart?.openCart) {
              miniCart.openCart();
            } else {
              window.setTimeout(() => { window.location.href = `${window.Shopify?.routes?.root || '/'}cart`; }, 250);
            }
          } catch (error) {
            promoAdd.disabled = false;
            promoAddLabel.textContent = promoAdd.dataset.defaultLabel;
            if (promoStatus) promoStatus.textContent = error.message || 'Unable to add this item. Please try again.';
          }
        });

        // If the visitor already told the theme their measurements, start from
        // those instead of the defaults — this is the same fit finder, not a
        // second opinion. assets/fit-finder.js is deferred, so it may land after
        // this script; the waist letter and the pre-sized free pair are filled
        // in when it does.
        const prefill = () => {
          const profile = window.OneBoneFit?.getProfile();
          if (profile?.captured) {
            if (height) height.value = profile.height;
            if (weight) weight.value = profile.weight;
            if (waist && profile.hasBottom) waist.value = profile.waist;
          }
          update();
        };

        update();
        if (window.OneBoneFit) {
          prefill();
        } else {
          document.addEventListener('onebone:fit:ready', prefill, { once: true });
        }
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-guided-outfit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const matrix=[{max:179,s:['-2','-2','-2','-1','-1','-1','-1']},{max:189,s:['-1','-1','-1','-1','-1','-1','-1']},{max:199,s:['0','0','-1','-1','-1','-1','-1']},{max:209,s:['0','0','0','0','0','0','0']},{max:219,s:['0','0','0','0','0','0','0']},{max:229,s:['0','0','0','0','0','0','0']},{max:239,s:['0','0','0','0','0','0','0']},{max:249,s:['0','0','0','0','0','0','0']},{max:259,s:['1','1','1','0','0','0','0']},{max:269,s:['1','1','1','1','1','1','1']},{max:279,s:['2','1','1','1','1','1','1']},{max:289,s:['2','2','1','1','1','1','1']},{max:299,s:['2','2','1','1','1','1','1']},{max:309,s:['2','2','1','1','1','1','1']},{max:319,s:['3','3','2','2','2','1','1']},{max:329,s:['3','3','2','2','2','2','2']},{max:339,s:['3','3','3','3','3','3','3']},{max:349,s:['4','4','3','3','3','3','3']},{max:359,s:['4','4','3','3','3','3','3']},{max:369,s:['4','4','4','4','4','4','4']},{max:379,s:['4','4','4','4','4','4','4']},{max:389,s:['5','5','4','4','4','3','3']},{max:399,s:['5','5','5','4','4','4','4']},{max:409,s:['5','5','5','5','5','5','5']},{max:419,s:['5','5','5','5','5','5','5']},{max:429,s:['5','5','5','5','5','5','5']},{max:439,s:['6','5','5','5','5','5','5']},{max:449,s:['6','6','6','6','6','6','6']},{max:459,s:['6','6','6','6','6','6','6']},{max:469,s:['6','6','6','6','6','6','6']},{max:479,s:['6','6','6','6','6','6','6']},{max:489,s:['6','6','6','6','6','6','6']},{max:499,s:['7','7','7','7','7','7','7']},{max:Infinity,s:['7','7','7','7','7','7','7']}];
    const bottoms=[{min:30,max:33,size:'A'},{min:34,max:37,size:'B'},{min:38,max:40,size:'C'},{min:41,max:44,size:'D'},{min:45,max:49,size:'E'},{min:50,max:54,size:'F'},{min:55,max:60,size:'G'},{min:61,max:65,size:'H'}];
    const column=(h)=>h<=68?0:h<=71?1:h<=74?2:h<=77?3:h<=80?4:h<=83?5:6;
    const normalize=(v)=>String(v||'').toLowerCase().replace(/^size\s*/,'').replace(/\s*\([^)]*\)\s*$/,'').trim();
    const saved=(keys)=>{for(const key of keys){try{const value=localStorage.getItem(key);if(value)return value;}catch(error){}}return''};

    const init=(scope=document)=>scope.querySelectorAll('[data-obgo]').forEach((root)=>{
      if(root.dataset.ready==='true')return;root.dataset.ready='true';
      const modal=root.querySelector('[data-obgo-modal]');
      const data=JSON.parse(root.querySelector('[data-obgo-data]')?.textContent||'{"paths":[],"recommendations":[]}');
      const screens={paths:root.querySelector('[data-obgo-path-screen]'),fit:root.querySelector('[data-obgo-fit-screen]'),product:root.querySelector('[data-obgo-product-screen]'),empty:root.querySelector('[data-obgo-empty-screen]')};
      const height=root.querySelector('[data-obgo-height]'),weight=root.querySelector('[data-obgo-weight]'),waist=root.querySelector('[data-obgo-waist]');
      const heightOut=root.querySelector('[data-obgo-height-output]'),weightOut=root.querySelector('[data-obgo-weight-output]'),waistOut=root.querySelector('[data-obgo-waist-output]');
      const topOut=root.querySelector('[data-obgo-top-size]'),bottomOut=root.querySelector('[data-obgo-bottom-size]');
      const productImage=root.querySelector('[data-obgo-product-image]'),productHeading=root.querySelector('[data-obgo-product-heading]'),productCopy=root.querySelector('[data-obgo-product-copy]'),productEyebrow=root.querySelector('[data-obgo-product-eyebrow]');
      const productTitle=root.querySelector('[data-obgo-product-title]'),variantTitle=root.querySelector('[data-obgo-variant-title]'),price=root.querySelector('[data-obgo-price]'),sizeBadge=root.querySelector('[data-obgo-product-size]'),details=root.querySelector('[data-obgo-details]');
      const progress=root.querySelector('[data-obgo-progress]'),add=root.querySelector('[data-obgo-add]'),addLabel=root.querySelector('[data-obgo-add-label]'),status=root.querySelector('[data-obgo-status]');
      let profile={top:String(root.dataset.customerTopSize||'').trim()||saved(['oneboneLockedTopSize','sizeTop','tops-product-size']),bottom:String(root.dataset.customerBottomSize||'').trim()||saved(['sizeBottom','bottoms-product-size'])};
      let activePath='',sequence=[],index=0,selectedVariant=null;
      const defaultAddLabel=addLabel?.textContent.trim()||'Add to bag';
      const show=(name)=>Object.entries(screens).forEach(([key,node])=>{if(node)node.hidden=key!==name});
      const open=()=>{show('paths');modal?.showModal();document.body.classList.add('obgo-modal-open')};
      const close=()=>{modal?.close();document.body.classList.remove('obgo-modal-open')};
      root.querySelectorAll('[data-obgo-open]').forEach((button)=>button.addEventListener('click',open));
      const anchor=root.dataset.triggerAnchor;
      if(anchor){document.querySelectorAll(`a[href="#${CSS.escape(anchor)}"],button[data-ob-guided-shop="${CSS.escape(anchor)}"]`).forEach((trigger)=>{if(trigger.dataset.obgoBound===root.id)return;trigger.dataset.obgoBound=root.id||anchor;trigger.addEventListener('click',(event)=>{event.preventDefault();open()})})}
      root.querySelector('[data-obgo-close]')?.addEventListener('click',close);
      modal?.addEventListener('close',()=>document.body.classList.remove('obgo-modal-open'));
      modal?.addEventListener('click',(event)=>{if(event.target===modal)close()});
      root.querySelectorAll('[data-obgo-back-paths]').forEach((button)=>button.addEventListener('click',()=>show('paths')));

      const updateFit=()=>{const h=Number(height?.value||72),w=Number(weight?.value||260),ws=Number(waist?.value||40);profile.top=(matrix.find((row)=>w<=row.max)||matrix[matrix.length-1]).s[column(h)];profile.bottom=(bottoms.find((range)=>ws>=range.min&&ws<=range.max)||bottoms[0]).size;if(heightOut)heightOut.textContent=`${Math.floor(h/12)}'${h%12}"`;if(weightOut)weightOut.textContent=w>=500?'500 lb+':`${w} lb`;if(waistOut)waistOut.textContent=`${ws} in`;if(topOut)topOut.textContent=profile.top;if(bottomOut)bottomOut.textContent=profile.bottom};
      height?.addEventListener('input',updateFit);weight?.addEventListener('input',updateFit);waist?.addEventListener('input',updateFit);
      const fitNeeded=()=>sequence.some((item)=>item.sizeSource!=='none'&&!profile[item.sizeSource]);
      const startPath=(key)=>{activePath=key;sequence=(data.recommendations||[]).filter((item)=>item.enabled&&item.path===key).sort((a,b)=>Number(a.step)-Number(b.step)).slice(0,5);index=0;if(!sequence.length){show('empty');return}if(fitNeeded()){updateFit();show('fit')}else renderProduct()};
      root.querySelectorAll('[data-obgo-path]').forEach((button)=>button.addEventListener('click',()=>startPath(button.dataset.obgoPath)));
      root.querySelector('[data-obgo-lock-fit]')?.addEventListener('click',()=>{updateFit();try{localStorage.setItem('oneboneLockedTopSize',profile.top);localStorage.setItem('sizeTop',profile.top);localStorage.setItem('tops-product-size',profile.top);localStorage.setItem('sizeBottom',profile.bottom);localStorage.setItem('bottoms-product-size',profile.bottom);localStorage.setItem('oneboneLockedWaist',String(waist?.value||40))}catch(error){}renderProduct()});

      const chooseVariant=(item)=>{if(item.sizeSource==='none')return item.variants.find((variant)=>variant.available)||item.variants[0]||null;const wanted=profile[item.sizeSource];const matches=item.variants.filter((variant)=>normalize(variant.options?.[item.sizeIndex])===normalize(wanted));return matches.find((variant)=>variant.available)||matches[0]||null};
      const renderProduct=()=>{const item=sequence[index];if(!item){finish();return}selectedVariant=chooseVariant(item);const selectedSize=item.sizeSource==='none'?'Ready':profile[item.sizeSource];const image=(!item.imageOverride&&selectedVariant?.image)||item.image;if(productImage){productImage.src=image||'';productImage.alt=item.title||item.heading||'';productImage.hidden=!image}if(productHeading)productHeading.textContent=item.heading||item.title||'';if(productCopy)productCopy.innerHTML=item.copy||'';if(productEyebrow)productEyebrow.textContent=item.eyebrow||'Built for your next room';if(productTitle)productTitle.textContent=item.title||'';if(variantTitle)variantTitle.textContent=selectedVariant?.title||'';if(price)price.textContent=selectedVariant?.price||'';if(sizeBadge)sizeBadge.textContent=selectedSize;if(details){details.href=selectedVariant?`${item.url}?variant=${selectedVariant.id}`:item.url||'';details.hidden=!item.url}if(progress)progress.textContent=`Piece ${index+1} of ${sequence.length}`;if(add){add.disabled=!selectedVariant?.available}if(addLabel)addLabel.textContent=selectedVariant?.available?(item.addLabel||defaultAddLabel):'Size unavailable';if(status)status.textContent=selectedVariant?.available?'':`This piece is not currently available in size ${selectedSize}.`;show('product')};
      const addToCart=async(id)=>{const form=new FormData();form.append('id',id);form.append('quantity','1');form.append('properties[_Guided outfit]',activePath);const helper=window.Alpine?.store?.('xCartHelper');if(helper){form.append('sections',helper.getSectionsToRender().map((section)=>section.id));form.append('sections_url',window.location.pathname)}const endpoint=window.Eurus?.cart_add_url||`${window.Shopify?.routes?.root||'/'}cart/add.js`;const response=await fetch(endpoint,{method:'POST',headers:{Accept:'application/javascript','X-Requested-With':'XMLHttpRequest'},body:form});const result=await response.json();if(!response.ok||result.status===422)throw new Error(result.description||'Unable to add this piece.');if(helper&&result.sections)helper.reRenderSections(result.sections);document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));return result};
      const finish=()=>{close();const miniCart=window.Alpine?.store?.('xMiniCart');if(miniCart?.openCart){miniCart.openCart()}else{window.location.href=`${window.Shopify?.routes?.root||'/'}cart`}};
      const next=()=>{index+=1;if(index>=sequence.length)finish();else renderProduct()};
      add?.addEventListener('click',async()=>{if(!selectedVariant?.available)return;add.disabled=true;if(addLabel)addLabel.textContent='Adding…';if(status)status.textContent='';try{await addToCart(selectedVariant.id);if(addLabel)addLabel.textContent='Added ✓';if(status)status.textContent='In your bag. Here’s the next piece.';window.setTimeout(next,450)}catch(error){add.disabled=false;if(addLabel)addLabel.textContent=defaultAddLabel;if(status)status.textContent=error.message||'Unable to add this piece. Please try again.'}});
      root.querySelector('[data-obgo-skip]')?.addEventListener('click',next);
      updateFit();
    });
    init();document.addEventListener('shopify:section:load',(event)=>init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-new-customer"] && !Shopify.designMode) return;
  try {
    
(()=>{const f=i=>`${Math.floor(i/12)}'${i%12}"`,matrix=[{max:179,s:["-2","-2","-2","-1","-1","-1","-1"]},{max:189,s:["-1","-1","-1","-1","-1","-1","-1"]},{max:199,s:["0","0","-1","-1","-1","-1","-1"]},{max:209,s:["0","0","0","0","0","0","0"]},{max:219,s:["0","0","0","0","0","0","0"]},{max:229,s:["0","0","0","0","0","0","0"]},{max:239,s:["0","0","0","0","0","0","0"]},{max:249,s:["0","0","0","0","0","0","0"]},{max:259,s:["1","1","1","0","0","0","0"]},{max:269,s:["1","1","1","1","1","1","1"]},{max:279,s:["2","1","1","1","1","1","1"]},{max:289,s:["2","2","1","1","1","1","1"]},{max:299,s:["2","2","1","1","1","1","1"]},{max:309,s:["2","2","1","1","1","1","1"]},{max:319,s:["3","3","2","2","2","1","1"]},{max:329,s:["3","3","2","2","2","2","2"]},{max:339,s:["3","3","3","3","3","3","3"]},{max:349,s:["4","4","3","3","3","3","3"]},{max:359,s:["4","4","3","3","3","3","3"]},{max:369,s:["4","4","4","4","4","4","4"]},{max:379,s:["4","4","4","4","4","4","4"]},{max:389,s:["5","5","4","4","4","3","3"]},{max:399,s:["5","5","5","4","4","4","4"]},{max:409,s:["5","5","5","5","5","5","5"]},{max:419,s:["5","5","5","5","5","5","5"]},{max:429,s:["5","5","5","5","5","5","5"]},{max:439,s:["6","5","5","5","5","5","5"]},{max:449,s:["6","6","6","6","6","6","6"]},{max:459,s:["6","6","6","6","6","6","6"]},{max:469,s:["6","6","6","6","6","6","6"]},{max:479,s:["6","6","6","6","6","6","6"]},{max:489,s:["6","6","6","6","6","6","6"]},{max:499,s:["7","7","7","7","7","7","7"]},{max:Infinity,s:["7","7","7","7","7","7","7"]}],heightColumn=h=>h<=68?0:h<=71?1:h<=74?2:h<=77?3:h<=80?4:h<=83?5:6;document.querySelectorAll("[data-ob-fit-tool]").forEach(tool=>{if(tool.dataset.ready)return;tool.dataset.ready="true";const h=tool.querySelector(".js-ob-height"),w=tool.querySelector(".js-ob-weight"),hv=tool.querySelector(".js-ob-height-value"),wv=tool.querySelector(".js-ob-weight-value"),s=tool.querySelector(".js-ob-shirt-size"),n=tool.querySelector(".js-ob-fit-note"),unit=tool.dataset.weightUnit||"lb",notes={"-2":tool.getAttribute("data-note-size-minus-2"),"-1":tool.getAttribute("data-note-size-minus-1"),"0":tool.getAttribute("data-note-size-0"),"1":tool.getAttribute("data-note-size-1"),"2":tool.getAttribute("data-note-size-2"),"3":tool.getAttribute("data-note-size-3"),"4":tool.getAttribute("data-note-size-4"),"5":tool.getAttribute("data-note-size-5"),"6":tool.getAttribute("data-note-size-6"),"7":tool.getAttribute("data-note-size-7")},u=()=>{const ih=Number(h.value),iw=Number(w.value),row=matrix.find(r=>iw<=r.max)||matrix[matrix.length-1],size=row.s[heightColumn(ih)];hv.textContent=f(ih);wv.textContent=iw>=500?`500${unit}+`:`${iw} ${unit}`;s.textContent=size;n.textContent=notes[size]||notes["2"]};h.addEventListener("input",u);w.addEventListener("input",u);u()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-signup-modal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DISMISS_KEY = 'ob-signup-dismissed:';
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

    function readStore(key) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    }

    function writeStore(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        /* Private browsing or blocked storage — the popup still works, it just reappears. */
      }
    }

    function clearStore(key) {
      try {
        window.localStorage.removeItem(key);
      } catch (error) {
        /* No-op. */
      }
    }

    function setupOBSignup(root) {
      if (root.dataset.obSignupReady === 'true') return;
      root.dataset.obSignupReady = 'true';

      const dialog = root.querySelector('.ob-signup__dialog');
      const slot = root.querySelector('[data-ob-signup-slot]');
      const closers = Array.from(root.querySelectorAll('[data-ob-signup-close]'));
      const overlay = root.querySelector('[data-ob-signup-overlay]');

      if (!dialog) return;

      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      const dismissKey = DISMISS_KEY + root.dataset.obSignupId;
      const reappearDays = parseInt(root.dataset.obSignupReappear, 10) || 0;

      let lastFocused = null;
      let armed = false;

      function remember() {
        if (readStore(dismissKey) === 'never') return;
        if (reappearDays <= 0) {
          writeStore(dismissKey, 'never');
          return;
        }
        writeStore(dismissKey, String(Date.now() + reappearDays * 86400000));
      }

      function dismissed() {
        const stored = readStore(dismissKey);
        if (!stored) return false;
        if (stored === 'never') return true;
        const until = parseInt(stored, 10);
        if (!until || Number.isNaN(until)) return false;
        if (Date.now() >= until) {
          clearStore(dismissKey);
          return false;
        }
        return true;
      }

      function focusable() {
        return Array.from(dialog.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null || el === document.activeElement);
      }

      function trapFocus(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          return;
        }
        if (event.key !== 'Tab') return;
        const items = focusable();
        if (items.length === 0) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      function open() {
        if (root.classList.contains('is-open')) return;
        lastFocused = document.activeElement;
        root.hidden = false;
        root.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(() => root.classList.add('is-visible'));
        document.addEventListener('keydown', trapFocus);
        const target = focusable()[0];
        if (target) {
          window.setTimeout(() => target.focus({ preventScroll: true }), 60);
        }
      }

      function close() {
        if (!root.classList.contains('is-open')) return;
        root.classList.remove('is-visible');
        document.removeEventListener('keydown', trapFocus);
        document.body.style.overflow = '';
        window.setTimeout(() => {
          root.classList.remove('is-open');
          root.hidden = true;
        }, 220);
        if (!designMode) remember();
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus({ preventScroll: true });
      }

      function threshold() {
        const mobileDepth = parseInt(root.dataset.obSignupDepthMobile, 10) || 0;
        const desktopDepth = parseInt(root.dataset.obSignupDepth, 10) || 0;
        if (mobileDepth > 0 && window.matchMedia('(max-width: 749px)').matches) return mobileDepth;
        return desktopDepth;
      }

      function onScroll() {
        if (window.scrollY < threshold()) return;
        disarm();
        open();
      }

      function disarm() {
        if (!armed) return;
        armed = false;
        window.removeEventListener('scroll', onScroll);
      }

      function arm() {
        if (armed) return;
        armed = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      closers.forEach((closer) => closer.addEventListener('click', close));
      if (overlay) overlay.addEventListener('click', close);

      // Best effort: Shopify Forms publishes no submit event, so retire the popup
      // when a form inside the slot submits. If Forms ever stops emitting a native
      // submit event, the only cost is that the popup returns after the dismissal
      // window instead of for good.
      if (slot) {
        slot.addEventListener(
          'submit',
          () => {
            writeStore(dismissKey, 'never');
          },
          true
        );
      }

      if (designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.target === root || event.target.contains(root)) open();
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.target === root || event.target.contains(root)) close();
        });
        return;
      }

      if (root.dataset.obSignupHasForm !== 'true') return;
      if (root.dataset.obSignupIsCustomer === 'true') return;
      if (root.dataset.obSignupMobile !== 'true' && window.matchMedia('(max-width: 749px)').matches) return;
      if (dismissed()) return;

      arm();
    }

    function initOBSignup(container) {
      const scope = container || document;
      scope.querySelectorAll('[data-ob-signup]').forEach(setupOBSignup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initOBSignup());
    } else {
      initOBSignup();
    }

    document.addEventListener('shopify:section:load', (event) => initOBSignup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onebone-starter-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.obStarterReady) return;
      root.dataset.obStarterReady = 'true';

      root.querySelectorAll('[data-ob-starter-card]').forEach((card) => {
        const gallery = card.querySelector('[data-ob-starter-gallery]');
        const track = card.querySelector('[data-ob-starter-gallery-track]');
        const dotsContainer = card.querySelector('[data-ob-starter-gallery-dots]');
        const previous = card.querySelector('[data-ob-starter-gallery-prev]');
        const next = card.querySelector('[data-ob-starter-gallery-next]');
        const title = card.querySelector('[data-ob-starter-title]');
        const price = card.querySelector('[data-ob-starter-price]');
        const compare = card.querySelector('[data-ob-starter-compare]');
        const status = card.querySelector('[data-ob-starter-status]');
        const dot = card.querySelector('.ob-starter__status-dot');
        const badge = card.querySelector('[data-ob-starter-badge]');
        const quick = card.querySelector('[data-ob-starter-quick-view]');
        const quickLabel = card.querySelector('[data-ob-starter-quick-label]');
        const variant = card.querySelector('[data-ob-starter-variant]');
        const swatches = [...card.querySelectorAll('[data-ob-starter-swatch]')];
        const galleryTemplates = [...card.querySelectorAll('[data-ob-starter-gallery-template]')];
        let slides = track ? [...track.querySelectorAll('.ob-starter__slide')] : [];
        let dots = dotsContainer ? [...dotsContainer.querySelectorAll('span')] : [];
        let activeIndex = 0;
        let scrollFrame;

        const rebuildDots = () => {
          if (!dotsContainer) return;
          dotsContainer.replaceChildren(...slides.map((slide, index) => {
            const dotElement = document.createElement('span');
            dotElement.classList.toggle('is-active', index === 0);
            return dotElement;
          }));
          dots = [...dotsContainer.querySelectorAll('span')];
        };

        const updateGallery = (index, smooth = true) => {
          if (!track || !slides.length) return;
          activeIndex = Math.max(0, Math.min(index, slides.length - 1));
          dots.forEach((item, dotIndex) => item.classList.toggle('is-active', dotIndex === activeIndex));
          track.scrollTo({ left: slides[activeIndex].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        };

        const loadGallery = (key, fallbackImage, detailUrl, imageAlt) => {
          const template = galleryTemplates.find((item) => item.dataset.galleryKey === key);
          if (template && track) {
            track.replaceChildren(template.content.cloneNode(true));
            slides = [...track.querySelectorAll('.ob-starter__slide')];
            rebuildDots();
          } else {
            const firstImage = track?.querySelector('.ob-starter__image');
            if (firstImage && fallbackImage) {
              firstImage.src = fallbackImage;
              firstImage.removeAttribute('srcset');
              firstImage.removeAttribute('sizes');
              firstImage.alt = imageAlt || '';
            }
          }
          gallery?.classList.toggle('is-single', slides.length <= 1);
          card.querySelectorAll('[data-ob-starter-link]').forEach((link) => {
            link.href = detailUrl;
            if (link.hasAttribute('data-ob-starter-media-link')) link.setAttribute('aria-label', imageAlt || '');
          });
          updateGallery(0, false);
        };

        previous?.addEventListener('click', () => updateGallery(activeIndex - 1));
        next?.addEventListener('click', () => updateGallery(activeIndex + 1));
        track?.addEventListener('scroll', () => {
          cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(() => {
            const closest = slides.reduce((best, slide, index) => (
              Math.abs(track.scrollLeft - slide.offsetLeft) < Math.abs(track.scrollLeft - slides[best].offsetLeft) ? index : best
            ), 0);
            activeIndex = closest;
            dots.forEach((item, dotIndex) => item.classList.toggle('is-active', dotIndex === activeIndex));
          });
        }, { passive: true });

        swatches.forEach((swatch) => swatch.addEventListener('click', () => {
          const data = swatch.dataset;
          const available = data.available === 'true';
          swatches.forEach((item) => {
            item.classList.toggle('is-active', item === swatch);
            item.setAttribute('aria-pressed', item === swatch ? 'true' : 'false');
          });
          loadGallery(data.galleryKey, data.image, data.detailUrl, data.title);
          if (title) title.textContent = data.title;
          if (price) {
            price.textContent = data.price;
            price.classList.toggle('is-sale', Boolean(data.compare));
          }
          if (compare) {
            compare.textContent = data.compare;
            compare.hidden = !data.compare;
          }
          if (status) status.textContent = available ? card.dataset.availableLabel : card.dataset.unavailableLabel;
          if (dot) dot.classList.toggle('is-unavailable', !available);
          if (badge) badge.hidden = available;
          if (quick) {
            quick.dataset.productUrl = data.productUrl;
            quick.disabled = !available;
            quick.setAttribute('aria-label', (card.dataset.chooseFor || '').replace('[product]', data.title || ''));
          }
          if (quickLabel) quickLabel.textContent = available ? card.dataset.chooseLabel : card.dataset.soldLabel;
          if (variant) variant.textContent = data.variantId || '';
        }));
      });

      if (
        root.classList.contains('has-swipe-cue') &&
        window.matchMedia('(max-width: 680px)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        const cueTrack = root.querySelector('[data-ob-starter-gallery-track]');
        let cueCancelled = false;
        cueTrack?.addEventListener('pointerdown', () => { cueCancelled = true; }, { once: true, passive: true });

        const cueObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting) || !cueTrack) return;
          cueObserver.disconnect();
          window.setTimeout(() => {
            if (cueCancelled || cueTrack.scrollWidth <= cueTrack.clientWidth) return;
            const cueDistance = Math.min(64, Math.max(40, cueTrack.clientWidth * 0.16));
            cueTrack.classList.add('is-swipe-cueing');
            cueTrack.scrollTo({ left: cueDistance, behavior: 'smooth' });
            window.setTimeout(() => cueTrack.scrollTo({ left: 0, behavior: 'smooth' }), 620);
            window.setTimeout(() => cueTrack.classList.remove('is-swipe-cueing'), 1250);
          }, 320);
        }, { threshold: 0.35 });

        cueObserver.observe(root);
      }
    };

    document.querySelectorAll('.ob-starter').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.ob-starter').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();
})();
